var map = {
	"./music-instructions.json": 4837,
	"./music-library-intro2024.json": 4838,
	"./music-library-launch2024.json": 4839,
	"./music-progression.json": 4840,
	"./startSourcesAdvanced.json": 4841,
	"./startSourcesSimple.json": 4842,
	"./startSourcesSimple2.json": 4843,
	"./startSourcesTracks.json": 4844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4532;